import { track as vercelTrack } from '@vercel/analytics'

// The funnel we actually care about: impression → visit → game started → first move
// → game completed → shared/feedback. Anything that doesn't move one of those
// transitions doesn't belong here.
export type GameEvent =
  | 'difficulty_selected'
  | 'game_started'
  | 'first_move_made'
  | 'game_completed'
  | 'player_won'
  | 'bot_battle_started'
  | 'result_shared'
  | 'feedback_opened'
  | 'feedback_submitted'

type Props = Record<string, string | number | boolean | null>

// Self-exclusion. Visiting /?notrack=1 once marks this browser as "don't count me"
// so the owner's own visits stop inflating the numbers; /?notrack=0 undoes it.
// Persisted in localStorage, so it survives reloads but is per-browser.
const NO_TRACK_KEY = 'cc-no-track'

export function initNoTrack(): void {
  try {
    const flag = new URLSearchParams(window.location.search).get('notrack')
    if (flag === '1') localStorage.setItem(NO_TRACK_KEY, '1')
    else if (flag === '0') localStorage.removeItem(NO_TRACK_KEY)
    if (flag !== null) {
      console.info(
        `[analytics] this browser is ${isNoTrack() ? 'EXCLUDED from' : 'included in'} analytics`,
      )
    }
  } catch {
    /* private mode / storage disabled */
  }
}

export function isNoTrack(): boolean {
  try {
    return localStorage.getItem(NO_TRACK_KEY) === '1'
  } catch {
    return false
  }
}

// Vercel Analytics no-ops outside a Vercel deployment, so `track` in dev is silent
// rather than broken. Still guarded: an analytics failure must never break a game.
export function track(event: GameEvent, props?: Props): void {
  if (isNoTrack()) return
  try {
    vercelTrack(event, props)
  } catch {
    /* analytics is best-effort */
  }
}
